module.exports = __webpack_public_path__ + "static/img/login_bg.4cd7021a.png";